import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private sidebarStatusSource = new BehaviorSubject<boolean>(false);
  sidebarStatus$ = this.sidebarStatusSource.asObservable();

  private sidebarDetailsSource = new BehaviorSubject<boolean>(false);
  sidebarDetailsSource$ = this.sidebarDetailsSource.asObservable();

  setSidebarStatus(status: boolean): void {
    this.sidebarStatusSource.next(status);
  }

  setSidebarDetailStatus(status: boolean): void {
    this.sidebarDetailsSource.next(status);
  }
}
